import MediumCard from './MediumCard';

export default MediumCard;
